import '@/scss/main.scss';

import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';
import Buefy from 'buefy';
import jwtDecode from 'jwt-decode';
import VueSession from 'vue-session';
import Vuelidate from 'vuelidate';
import VueMeta from 'vue-meta';

import App from './App.vue';
import router from './router';
import store from './store';
import axios from './utils/axios';
import { setSession, clearSession } from './utils/auth';

const options = {
  persist: true
};
const apikey = `${process.env.VUE_APP_MAP_KEY}`;
Vue.use(VueGoogleMaps, {
  load: {
    key: apikey
  }
});

Vue.use(Buefy);
Vue.use(Vuelidate);
Vue.use(VueMeta);
Vue.use(VueSession, options);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  data() {
    return {};
  },
  created() {
    axios.interceptors.request.use(
      config => {
        this.validateSession();
        return config;
      },
      error => Promise.reject(error)
    );
    this.validateSession();
  },
  onIdle() {
    this.validateSession();
  },
  onActive() {
    this.validateSession();
  },
  methods: {
    startSession(data) {
      this.$session.start();
      this.$session.set('user', data);
      this.$session.set('token', this.loggedUser.token);
      setSession(data);
      axios.defaults.headers.common.Authorization = `${this.loggedUser.token}`;
      store.commit('setLoggedUser', data);
    },
    endSession() {
      this.$session.clear();
      this.$session.destroy();
      clearSession();
      delete axios.defaults.headers.common.Authorization;
      store.commit('logout');
      setTimeout(() => {
        this.$router.push('/login');
        document.location.reload();
      }, 500);
    },
    resumeSession() {
      const token = this.$session.get('token');
      const user = this.$session.get('user');
      axios.defaults.headers.common.Authorization = `${token}`;
      store.commit('setLoggedUser', user);
    },
    validateSession() {
      if (this.isLoggedIn) {
        try {
          const token = jwtDecode(this.loggedUser.token);
          const time = Date.now().valueOf() / 1000;
          if (token.exp < time) {
            this.endSession();
          } else {
            this.resumeSession();
          }
        } catch (error) {
          this.endSession();
          return error;
        }
        return true;
      }
      return true;
    }
  },
  watch: {
    isLoggedIn(val) {
      if (val) {
        this.startSession(this.loggedUser);
        this.userId = this.loggedUser.id;
      }
    }
  },
  computed: {
    isLoggedIn() {
      return store.getters.isLoggedIn;
    },
    loggedUser() {
      return store.getters.getLoggedUser;
    }
  },
  render: h => h(App)
}).$mount('#app');
